export default "__VITE_ASSET__BNsnEKlf__"